export const DEFAULT_WORKSPACE_PRIMARY_COLOR = '#008080';

export const normalizeWorkspacePrimaryColor = (value) => {
  const raw = `${value || ''}`.trim();
  if (!raw) return '';

  const prefixed = raw.startsWith('#') ? raw : `#${raw}`;
  if (/^#[0-9a-fA-F]{3}$/.test(prefixed)) {
    return `#${prefixed.slice(1).split('').map((character) => character.repeat(2)).join('')}`.toUpperCase();
  }
  if (/^#[0-9a-fA-F]{6}$/.test(prefixed)) return prefixed.toUpperCase();
  return '';
};

export const workspacePrimaryColorWithAlpha = (value, alpha) => {
  const normalized = normalizeWorkspacePrimaryColor(value) || DEFAULT_WORKSPACE_PRIMARY_COLOR;
  const red = Number.parseInt(normalized.slice(1, 3), 16);
  const green = Number.parseInt(normalized.slice(3, 5), 16);
  const blue = Number.parseInt(normalized.slice(5, 7), 16);
  return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
};
